import React, { Component } from "react";
import { connect } from "react-redux";
import { updateCart, removeFromCart, saveCart } from "../actions/cartActions";
import { withTranslation } from 'react-i18next';
import { showInfo } from "../common/iziToast";
import * as Icons from "../common/icons";
import MenuCartLine from "../components/MenuCartLine";
import MobileCartLine from "../components/MobileCartLine";
import WebCartLine from "../components/WebCartLine";

class CartLine extends Component {
    constructor(props) {
        super(props);
        const { line } = this.props;
        this.state = {
            quantity: line.quantity
        };

        this.onQuantityChange = this.onQuantityChange.bind(this);
        this.onRemoveLine = this.onRemoveLine.bind(this);
        this.canPayWithLoyaltyPoints = this.canPayWithLoyaltyPoints.bind(this);
        this.onTogglePayWithLoyaltyPoints = this.onTogglePayWithLoyaltyPoints.bind(this);
    }

    canPayWithLoyaltyPoints(quantity = null) {
        const { user, cart, line } = this.props;
        if(!user || user.isAuthenticated === false || line.isPromo === true) {
            return false
        }
        const totalBalance = user.loyaltyPointsBalance;

        const usedPoints = cart.lines.reduce((total, item) => {
            return item.isLoyaltyPointsUsed ? total + item.loyaltyPoints : total;
        }, 0);

        const remainingBalance = totalBalance - usedPoints + (line.isLoyaltyPointsUsed ? line.loyaltyPoints : 0); // in case of quantity changing
        const checkQuantity = quantity !== null ? quantity : line.quantity;
        const itemLoyaltyPointsPrice = line.product.loyaltyPoints * checkQuantity;
        
        if (remainingBalance >= itemLoyaltyPointsPrice)
            return true
        else 
            return false
    }

    onTogglePayWithLoyaltyPoints(isLoyaltyPointsUsed) {
        const { stockItemId, isPromo, quantity } = this.props.line;
        this.props.updateCart(stockItemId, quantity, isPromo, isLoyaltyPointsUsed);
    }

    onQuantityChange(e) {
        const { line, t } = this.props;
        const { stockItemId, isPromo, isLoyaltyPointsUsed } = line;
        const newQuantity = parseInt(e.target.value, 10);

        if (isLoyaltyPointsUsed && !this.canPayWithLoyaltyPoints(newQuantity)) {
            showInfo(
                t("PayWithLoyaltyPoints"),
                t("InsufficientLoyaltyPointsBalance"),
                Icons.INFO,
            );
            return;
        }

        this.setState({ quantity: newQuantity });
        this.props.updateCart(stockItemId, newQuantity, isPromo, isLoyaltyPointsUsed);
    }

    onRemoveLine(e) {
        const { line, settings } = this.props;

        if (window.gtag) {
            window.gtag('event', 'remove_from_cart', {
                currency: settings.isoCurrencySymbol,
                items: [{
                    item_id: line.product.stockItemCode,
                    item_name: line.product.title,
                    item_category: line.product.groupName,
                    price: line.product.specialPrice,
                    currency: settings.isoCurrencySymbol,
                    quantity: line.quantity
                }],
                value: line.product.specialPrice
            });
        }

this.props.removeFromCart({
  stockItemId: line.stockItemId,
  isPromo: line.isPromo
});    }

    render() {
        const { line, isReadOnly, isMenu, isMobile, settings, user } = this.props;
        if (!line) return <div />;

        const displayPrice = line.isLoyaltyPointsUsed ? 0 : line.product.specialPrice;
        const calculatedTotal = this.state.quantity * displayPrice;

        if (isMenu) {
            return <MenuCartLine line={line} onRemoveLine={this.onRemoveLine} settings={settings} />
        }

        if (isMobile) {
            return <MobileCartLine line={line} isReadOnly={isReadOnly} totalQuantityPrice={calculatedTotal}
                onRemoveLine={this.onRemoveLine} onQuantityChange={this.onQuantityChange} settings={settings} user={user}
                canPayWithLoyaltyPoints={this.canPayWithLoyaltyPoints} onTogglePayWithLoyaltyPoints={this.onTogglePayWithLoyaltyPoints} />
        }

        return <WebCartLine line={line} isReadOnly={isReadOnly} totalQuantityPrice={calculatedTotal}
            onRemoveLine={this.onRemoveLine} onQuantityChange={this.onQuantityChange} settings={settings} user={user} 
            canPayWithLoyaltyPoints={this.canPayWithLoyaltyPoints} onTogglePayWithLoyaltyPoints={this.onTogglePayWithLoyaltyPoints} />


    }
}

function mapStateToProps({ cart, user, settings }, ownProps) {
    return { cart, user, settings, ...ownProps };
}

export default withTranslation()(connect(mapStateToProps, { updateCart, removeFromCart, saveCart })(CartLine));
